import React, { useEffect, useState } from "react";
import useOrderColumn from "./Hook/useOrderColumn";
import CommonHeader from "../../../Components/Common/CommonHeader/CommonHeader";
import TableWrapper from "../../../Components/Common/Tables/Tanstack/components/TableWrapper";
import UserFilter from "./OrderFilter";
import { useDispatch, useSelector } from "react-redux";
import { getOrderList } from "./OrderService";
import {
  checkAccessPermission,
  checkButtonAccess,
  getOrgId,
} from "../../../Utils/CommonUtils";
import PolicyModal from "./Modal/PolicyModal";
import LoadingSpinner from "../../../Components/Common/LoadingSpinner/LoadingSpinner";
import useRezReactTable from "../../../Components/Common/Tables/Tanstack/hooks/useRezReactTable";
import { getFilteredDataWithTabs } from "../../../Utils/CommonService";
import {
  setOrderFilterForm,
  setOrderList,
  setOrderSorting,
} from "../../../slices/orders/orderSlice";
import OrderFilter from "./OrderFilter";
import AdvancedFilter from "./AdvancedFilter";

function OrderListing() {
  const { orderColumn } = useOrderColumn();
  const dispatch = useDispatch();
  const orderData = useSelector((state) => state.order.orderList);
  const loader = useSelector((state) => state.common.tailSpinLoader);

  const [status, setSelectedOrderStatus] = useState("");
  const [created_date, setSelectedDateRange] = useState([]);
  const [code, setSearchedId] = useState("");
  // const totalRows = orderData ? orderData.length : 0;
  const totalRows = useSelector((state) => state.common.pagination.totalCount);
  const rowsPerPage = useSelector((state) => state.common.pagination.size);
  // const enterpriseId = useSelector((state) => state.common.user.enterpriseId);
  const pageNumber = useSelector((state) => state.common.pagination.page);
  const apiTabData = useSelector((state) => state.common.pagination.tabs);
  const filterApi = useSelector((state) => state.order.filter.filterApi);
  const filterFormCopy = useSelector((state) => state.order.filter.formCopy);
  const filterForm = useSelector((state) => state.order.filter.form);
  const sortColumn = useSelector((state) => state.order.sorting.column);
  const sortOrder = useSelector((state) => state.order.sorting.order);
  const accessData = useSelector((state) => state.common.sidebarData);
  const selectedUser = useSelector((state) => state.header.selectedUser);

  const userData = JSON.parse(localStorage.getItem("selectedUser")) || {};
  const { providerName } = userData;
  const enterpriseid = localStorage.getItem("enterpriseid");
  const userid = localStorage.getItem("userId");

  // const showNewButton = selectedUser.organization_type === "AGSA" || selectedUser.organization_type === "PSP";
  const canCreateOrder = checkButtonAccess("CREATE", "ORD_ORDS");

  const { setPagination } = useRezReactTable();
  const [isPaginationReset, setIsPaginationReset] = useState(false);
  const [isOffcanvasOpen, setOffcanvasOpen] = useState(false);

  const handleOpen = () => setOffcanvasOpen(true);
  const handleClose = () => setOffcanvasOpen(false);

  const resetPagination = () => {
    setIsPaginationReset(true);
    setPagination({
      page: 0,
      size: rowsPerPage,
    });
  };

  // useEffect(() => {
  //   resetPagination();
  //   // dispatch(setOrderFilterForm({ type: "reset" }));
  // }, [rowsPerPage]);

  const agId =
    selectedUser.entitytype === "AGRP" ? selectedUser.entityid : null;

  useEffect(() => {
    dispatch(setOrderFilterForm({ type: "reset" }));
  }, []);

  return (
    <div>
      <CommonHeader
        newButton={canCreateOrder}
        buttonTitle={"New"}
        formLink="/order/orders/create"
        filterComponent={<OrderFilter />}
        dash={true}
        filterIcon={true}
        offcanvasopen={handleOpen}
      />
      <div>
        <TableWrapper
          columns={orderColumn}
          data={orderData}
          apiTabData={apiTabData}
          paginatedApi
          filterApi={filterApi}
          filterApiEntity={"ODR"}
          filterApiListEntity={"USRO"}
          filterApiFunction={setOrderList}
          filterApiService={getFilteredDataWithTabs}
          filterForm={filterForm}
          totalRows={totalRows}
          status={"ALL"}
          statusColumn={"status"}
          hideTabsWrapper={true}
          serverSort
          serverSortColumn={sortColumn}
          serverSortOrder={sortOrder}
          serverSortState={setOrderSorting}
          enterpriseId={enterpriseid}
          userId={userid}
          agId={agId}
        />
      </div>
      <AdvancedFilter show={isOffcanvasOpen} onClose={handleClose} />
    </div>
  );
}

export default OrderListing;
